import { RFC3339timestamp, UUID } from "@bitory-gmbh/nidavellir";
import { arrayMove } from "@dnd-kit/sortable";

export type Catalog = {
  id: UUID;
  companyId: UUID;
  customerId?: UUID;
  name: string;
  description: string;
  active: boolean;
  items: CatalogItem[];
  createdAt: RFC3339timestamp;
  updatedAt: RFC3339timestamp;
};

export type CatalogItem = {
  id: UUID;
  catalogId: UUID;
  order: number;
  title: string;
  shorthand: string;
  text: string;
};

export function orderItems(
  items: CatalogItem[],
  oldIndex: number,
  newIndex: number,
): CatalogItem[] {
  const newItems = arrayMove(items, oldIndex, newIndex);
  return newItems.map((i, idx) => ({ ...i, order: idx }));
}
